var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade-fast", mode: "out-in" } }, [
    _c(
      "div",
      [
        _vm.showLoadingIndicator
          ? _c("LessonLoadingScreen", { on: { closeClicked: _vm.closeLesson } })
          : _vm.showErrorScreen
          ? _c("LessonErrorScreen", { on: { closeClicked: _vm.closeLesson } })
          : _vm._e(),
        _vm._v(" "),
        _c("DesktopOnlyModal", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDesktopOnlyModal,
              expression: "showDesktopOnlyModal"
            }
          ],
          attrs: {
            shouldLockScrollOnMount: _vm.showDesktopOnlyModal,
            trackingProperties: _vm.getTrackingProperties,
            isNative: _vm.isNative,
            courseSlug: _vm.courseSlug
          },
          on: { onBackToAllCourses: _vm.goToAllCourses }
        }),
        _vm._v(" "),
        _vm.showAdminFeatures && _vm.loadingError
          ? _c("div", { staticClass: "load-error" }, [
              _c(
                "div",
                [
                  _c("h1", [_vm._v("Oh, no! 😬")]),
                  _vm._v(" "),
                  _vm.loadingError === "missingJs"
                    ? _c("p", [
                        _vm._v(
                          "\n          This lesson has not been compiled yet. "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          This usually means that there was an error while saving or compiling this version of the\n          lesson. Edit this lesson to fix any problems and try again.\n        "
                        )
                      ])
                    : _vm.loadingError === "badFlags"
                    ? _c("p", [
                        _vm._v(
                          "\n          This lesson hasn't been compiled in a while. "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          This usually means that the frontend has gotten out of step with the runtime. Try\n          previewing this lesson in the editor again, and let an engineer know of the issue.\n        "
                        )
                      ])
                    : _vm.loadingError === "compilerError"
                    ? _c("div", [
                        _c("p", [
                          _vm._v(
                            "There was an error when compiling this lesson."
                          )
                        ]),
                        _vm._v(" "),
                        _c("code", [_vm._v(_vm._s(_vm.compilerErrorMessage))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn",
                      attrs: { to: _vm.editUrl, target: "_blank" }
                    },
                    [_vm._v(" Edit lesson ")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "main",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLesson,
                expression: "showLesson"
              }
            ],
            ref: "container",
            class: {
              "lesson-all": true,
              "viz-elm": true
            },
            style: { "--visible-banner-height": _vm.visibleBannerHeight + "px" }
          },
          [
            _vm.showAdminFeatures
              ? _c("AdminMenu", {
                  staticClass: "admin-menu",
                  attrs: {
                    "force-display": _vm.showAdminFeatures,
                    orientation: ["top", "right"],
                    badges: _vm.adminMenuData().badges,
                    items: _vm.adminMenuData().items
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { ref: "lesson" }),
            _vm._v(" "),
            _vm.showReportProblem
              ? _c("ReportProblem", {
                  class: {
                    "report-problem": true,
                    mobile: _vm.isMobile(_vm.$mq)
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.user.is_authenticated ? _c("StreakButtonWrapper") : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }